<fs-loader [isLoading]="isLoading">
    <router-outlet></router-outlet>
</fs-loader>
